import React from "react"

import {H1} from "@irati/ui/src/Typography"
import Tabs, {Tab} from "@irati/ui/src/Tabs"
import Flex from "@irati/ui/src/Flex"
import Spacing from "@irati/ui/src/Spacing"
import FormattedMessage, {injectIntl, InjectIntl} from "@irati/utils/lang"
import FormatMessage from "@irati/utils/lang/types/FormatMessage"
import {RedemptionReportDuration} from "@irati/types"

import TitleIcon from "../components/TitleIcon"
import TabContent from "../components/TabContent"

interface Props extends InjectIntl {}

const MySavings = ({formatMessage}: Props) => {
  const tabs = getTabs(formatMessage)
  return (
    <>
      <Flex alignItems="center" marginTop={5}>
        <TitleIcon />
        <H1 marginLeft={1.5}>
          <FormattedMessage id="platform.mySavings.header.copy" />
        </H1>
      </Flex>
      <Spacing marginTop={4}>
        <Tabs tabs={tabs} mountOnEnter unmountOnExit addMarginTop id="my-savings-tabs" />
      </Spacing>
    </>
  )
}

export default injectIntl(MySavings)

const getTabs = (formatMessage: FormatMessage): Tab[] => [
  {
    title: formatMessage({id: "platform.mySavings.tabs.month"}),
    key: "month",
    component: <TabContent duration={RedemptionReportDuration.Monthly} />
  },
  {
    title: formatMessage({id: "platform.mySavings.tabs.week"}),
    key: "week",
    component: <TabContent duration={RedemptionReportDuration.Last_7Days} />
  },
  {
    title: formatMessage({id: "platform.mySavings.tabs.year"}),
    key: "year",
    component: <TabContent duration={RedemptionReportDuration.Last_12Months} />
  }
]
